// How a promotion's demand change is written in a list row.
//
// `lift_value` is signed: a promotion can suppress demand as well as raise it
// (a competitor's sale, a presale window, a planned range-down), and the
// engine applies the number as a plain multiplier / additive quantity either
// way (api/services/promotion_engine.py, `_apply_lift_to_months`). The sign
// is therefore part of the value: a positive change keeps an explicit `+` so
// the merchant reads it as "on top of the usual forecast", a negative one
// carries the `-` the formatter already produced, and zero — a pricing-only
// promotion — is shown bare.
//
// `formatNumber` is the merchant's locale formatter (useFormatters); only the
// rule lives here.

export function formatLiftValue(formatNumber, liftType, liftValue) {
  const n = Number(liftValue);
  const v = formatNumber(liftValue, liftType === 'percentage' ? 0 : 1);
  return {
    signed: n > 0 ? `+${v}` : v,
    // Plural forms follow the magnitude: "-1 unit", not "-1 units".
    count: Math.abs(n),
  };
}
